import { reportsAgentIt } from './reportsAgent';
import { step5It } from './step5';
// Italian locale. Mirrors every key in ./en.js. Natural, professional business
// Italian for a goods business (distributor / wholesaler / manufacturer).
// {variable} placeholders are preserved exactly. Any key missing here falls back
// to the English string in ../i18n t().
const it = {
  // ── language switcher ──
  'lang.it': 'Italiano',
  'lang.en': 'Inglese',

  // ── nav (AppHeader) ──
  'nav.home': 'Home',
  'nav.dashboard': 'Dashboard',
  'nav.cases': 'Pratiche',
  'nav.inventory': 'Magazzino',
  'nav.schedule': 'Agenda',
  'nav.reports': 'Report',
  'production.title': 'Produzione',
  'production.enable': 'Configura la produzione (aggiungi una ricetta)',
  'nav.voice': 'Voce',
  'nav.readyToOrder': '{n} da ordinare',

  // ── Home ──
  'home.greeting': 'Panoramica',
  'home.sub.loading': 'Caricamento',
  'home.sub.caughtUp': 'Nessun elemento richiede attenzione',
  'home.sub.attentionOne': '1 elemento richiede attenzione',
  'home.sub.attentionMany': '{n} elementi richiedono attenzione',
  'home.settings': 'Impostazioni',
  'home.askHint': 'Poni una domanda o impartisci un comando',
  'home.tile.cases': 'Pratiche',
  'home.tile.schedule': 'Agenda',
  'home.tile.dashboard': 'Dashboard',
  'home.tile.reports': 'Report',
  'home.tile.inventory': 'Magazzino',
  'home.tile.cases.sub': 'Fatture da verificare',
  'home.tile.cases.badge': '{n} da verificare',
  'home.tile.schedule.sub': 'Elementi pianificati',
  'home.tile.schedule.overdue': '{n} in ritardo',
  'home.tile.dashboard.sub': 'Andamento',
  'home.tile.reports.sub': 'Riepilogo economico',
  'home.tile.reports.sub.agent': 'Provvigioni e analisi',
  'home.tile.cases.count': '{n} da verificare',
  'home.tile.inventory.count': '{n} articoli in magazzino',
  'home.tile.schedule.count': '{n} in arrivo',
  'home.tile.inventory.sub': 'Giacenza',
  'home.tile.inventory.low': '{n} sotto la scorta minima',
  'home.value.title': 'Anomalie rilevate',
  'home.value.caught': 'recuperati su fatture fornitore',
  'home.value.billChecked': 'fattura controllata',
  'home.value.billsChecked': 'fatture controllate',
  'home.value.lowOne': 'articolo sotto la scorta minima',
  'home.value.lowMany': 'articoli sotto la scorta minima',

  // ── Settings ──
  'settings.title': 'Impostazioni',
  'settings.subtitle': 'Account e configurazione.',
  'settings.comingSoon': 'Prossimamente',
  'settings.section.account': 'Account',
  'settings.section.team': 'Membri del team',
  'settings.section.admin': 'Amministrazione Floxir',
  'settings.section.email': 'Email',
  'settings.section.notifications': 'Notifiche',
  'settings.section.autoReorder': 'Riordino automatico',
  'settings.section.billing': 'Fatturazione',
  'settings.account.company': 'Azienda',
  'settings.account.email': 'La tua email',
  'settings.account.empty': "I dati aziendali e dell'account compaiono dopo l'accesso.",
  'settings.signOut': 'Esci',
  'settings.signingOut': 'Disconnessione…',
  'settings.team.invite': "Invita un collega in questo spazio di lavoro. Riceverà un'email per impostare la password e avrà accesso ai dati della stessa azienda.",
  'settings.team.placeholder': 'collega@tuazienda.it',
  'settings.team.send': 'Invia invito',
  'settings.team.sending': 'Invio in corso…',
  'settings.team.enterEmail': 'Inserisci un indirizzo email.',
  'settings.team.onlyAdmin': 'Solo un titolare o un amministratore può invitare i colleghi.',
  'settings.admin.create': 'Crea un nuovo cliente',
  'settings.admin.createHelp': 'Crea uno spazio di lavoro aziendale e invita il titolare via email.',
  'settings.email.note': 'La corrispondenza con i fornitori viene inviata da questo indirizzo:',
  'settings.email.sentFrom': 'Inviato da',
  'settings.email.loadError': "Non è stato possibile caricare l'indirizzo del mittente.",
  'settings.email.none': 'Nessun indirizzo mittente configurato.',
  'settings.email.later': "L'invio dal proprio indirizzo e l'instradamento delle risposte dei fornitori sono configurabili in seguito.",
  'settings.notifications.banner': 'Mostra un avviso quando Floxir prepara degli ordini',
  'settings.notifications.bannerHelp': 'Mostra un avviso quando ci sono ordini preparati in attesa di approvazione.',
  'settings.autoReorder.manage': 'Gestisci le regole di riordino automatico',
  'settings.autoReorder.manageHelp': 'Configura il riordino automatico, i punti di riordino e le quantità.',
  'settings.billing.note': 'Piano e storico fatturazione.',

  // ── Dashboard (visible chrome) ──
  'dash.filter.week': 'Questa settimana',
  'dash.filter.month': 'Questo mese',
  'dash.filter.quarter': 'Questo trimestre',
  'dash.filter.year': "Quest'anno",
  'dash.loading': 'Caricamento…',
  'dash.error': 'Non è stato possibile caricare la dashboard: {msg}',
  'dash.empty': 'Nessun ordine, fattura o pratica registrata. I dati compaiono dopo l\'elaborazione dei documenti.',
  'dash.badge.healthy': 'Tutto in regola',
  'dash.badge.attention': 'Richiede attenzione',
  'dash.section.insights': 'Approfondimenti',
  'dash.section.money': 'Denaro',
  'dash.section.atWork': 'Elaborazione',
  'dash.section.trends': 'Andamenti',
  'dash.card.stillToPay': 'Ancora da pagare',
  'dash.card.stillToPay.agent': 'In attesa di pagamento',
  'dash.card.caught': 'Anomalie rilevate',
  'dash.card.moneyOverTime': 'Anomalie nel tempo',
  'dash.card.last6': 'Ultimi 6 mesi',
  'dash.card.whereMoney': 'Spesa per fornitore',
  'dash.card.whereMoney.agent': 'Dove si concentra il valore degli affari',
  'dash.card.topSuppliers': 'Principali fornitori per spesa',
  'dash.card.topSuppliers.agent': 'Principali fornitori per valore degli affari',
  'dash.card.upcoming': 'Pagamenti in arrivo',
  'dash.card.upcoming.agent': 'Scadenze in arrivo',
  'dash.card.suppliers': 'Fornitori',
  'dash.stat.docsRead': 'Documenti letti',
  'dash.stat.docsReadSub': 'ordini, bolle e fatture',
  'dash.stat.cleared': 'Sistemate automaticamente',
  'dash.stat.errors': 'Fatture con errori',

  // ── Cases (visible chrome) ──
  'cases.loading': 'Caricamento…',
  'cases.addDocument': 'Aggiungi un documento',
  'cases.photoOrUpload': 'Foto o file',
  'cases.justArrived': 'Appena arrivato',
  'cases.reading': 'Elaborazione documenti…',
  'cases.seeHistory': 'Storico documenti',
  'cases.matched': 'Abbinata',

  // ── Inventory (visible chrome) ──
  'inv.scan': 'Scansiona',
  'inv.searchPlaceholder': 'Cerca articoli',
  'inv.allSuppliers': 'Tutti i fornitori',
  'inv.col.item': 'Articolo',
  'inv.col.supplier': 'Fornitore',
  'inv.col.inStock': 'In giacenza',
  'inv.col.onOrder': 'In ordine',
  'inv.col.received': 'Ricevuti',
  'inv.col.paid': 'Pagati',
  'inv.col.status': 'Stato',
  'inv.section.products': 'Prodotti',
  'inv.productsInStock': 'Prodotti in giacenza',
  'inv.stockValue': 'Valore di magazzino',
  'inv.section.raw': 'Materie prime',
  'inv.section.finished': 'Prodotti finiti',
  'inv.loading': 'Caricamento…',
  'inv.empty': 'Nessun articolo in magazzino.',
  'inv.noMatch': 'Nessun articolo corrisponde ai filtri selezionati.',

  // ── Schedule (visible chrome) ──
  'sched.overdue': 'In ritardo',
  'sched.thisWeek': 'Questa settimana',
  'sched.nextWeek': 'Prossima settimana',
  'sched.chase': 'Invia sollecito',
  'sched.to': 'A',
  'sched.subject': 'Oggetto',
  'sched.messageItalian': 'Messaggio',
  'sched.expected': 'Previsto',

  // ── New today (bozza italiana, da rivedere) ──
  'needs.title': 'Novità di oggi',
  'needs.row.price_above_order': "Prezzo superiore all'ordine",
  'needs.row.duplicate_invoice': 'Fattura duplicata',
  'needs.row.order_missing': 'Ordine mancante',
  'needs.row.documents_overdue': 'Documenti in ritardo',
  'needs.row.vat_error': 'Errore IVA',
  'needs.new': '{n} nuovi',
  'needs.unavailable': '–',
  'needs.filter.today': 'Novità di oggi',
  'needs.filter.open': 'Tutte le aperte',
  'needs.showOpen': 'Mostra tutte le aperte di questo tipo',
  'needs.showToday': 'Mostra solo le novità di oggi',
  'needs.back': 'Pratiche',
  'needs.error': 'Impossibile caricare questo elenco. Meglio nessun elenco che uno che non corrisponde al numero.',
  'needs.missingSome': '{n} di queste pratiche non sono mostrate in questa pagina.',
  'needs.empty': 'Niente qui.',

  // ── Intestazione e Home ridisegnate (bozza italiana, da rivedere) ──
  'header.upload': 'Carica',
  'header.ask': 'Chiedi',
  'header.search': 'Cerca',
  'header.settings': 'Impostazioni',
  'header.searchSoon': 'La ricerca arriverà presto',
  'header.close': 'Chiudi',
  'header.mainMenu': 'Principale',
  'header.company': 'Azienda',
  'header.conversation': 'Conversazione in corso',
  'home.askByVoice': 'Chiedi a voce',
  'biz.agent': 'Agente',
  'biz.distributor': 'Distributore',
  'biz.manufacturer': 'Produttore',
  'biz.hybrid': 'Ibrido',
  'settings.language': 'Lingua',

  // ── Ricerca (barra sotto l'intestazione e pagina dei risultati) — bozza italiana, da rivedere ──
  'search.placeholder': "Cerca un numero d'ordine, un numero di fattura, un fornitore o un cliente",
  'search.closeLabel': 'Chiudi la ricerca',
  'search.tooShort': 'Minimo 3 caratteri',
  // ── Cases lists for agents (redesign step 3, piece 4) ──
  'cases.list.back': 'Torna alle pratiche',
  'cases.list.companies.all': 'Tutte le aziende',
  'cases.list.companies.one': '1 azienda',
  'cases.list.companies.many': '{n} aziende',
  'cases.list.sortAndDates': 'Ordine e date',
  'cases.list.sort.recent': 'Più recenti',
  'cases.list.sort.value': 'Più valore',
  'cases.list.sort.due': 'Scadenza più vicina',
  'cases.list.sort.custom': 'Personalizzato',
  'cases.list.dates.from': 'Dal',
  'cases.list.dates.to': 'al',
  'cases.list.dates.invalid': 'La prima data non può essere dopo la seconda.',
  'cases.list.tabs': 'Tipi',
  'cases.list.tab.attention.all': 'Tutte',
  'cases.list.tab.attention.price': "Prezzo superiore all'ordine",
  'cases.list.tab.attention.quantity': 'Quantità diversa',
  'cases.list.tab.attention.charge_not_ordered': 'Costo non ordinato',
  'cases.list.tab.attention.missing_line': 'Riga mancante',
  'cases.list.tab.attention.documents_late': 'Documenti in ritardo',
  'cases.list.tab.attention.duplicate': 'Fattura duplicata',
  'cases.list.tab.attention.order_missing': 'Ordine mancante',
  'cases.list.tab.attention.confirmation_differs': 'Conferma diversa',
  'cases.list.tab.attention.delivery_vs_packing': 'Bolla di consegna e packing list diverse',
  'cases.list.tab.open.all': 'Tutte',
  'cases.list.tab.open.invoice': 'In attesa della fattura',
  'cases.list.tab.open.delivery': 'In attesa della consegna',
  'cases.list.tab.open.not_confirmed': 'Non confermate',
  'cases.list.tab.matched.all': 'Tutte',
  'cases.list.tab.matched.internal_po': 'PO interno',
  'cases.list.tab.done.all': 'Tutte',
  'cases.list.chip.order': 'Ordine',
  'cases.list.chip.confirmation': 'Conferma',
  'cases.list.chip.delivery': 'Bolla di consegna',
  'cases.list.chip.invoice': 'Fattura',
  'cases.list.assumed': 'stimata',
  'cases.list.chip.paid': 'Pagato',
  'cases.list.chip.packing_list': 'Packing list',
  'cases.list.chip.due': 'Scade {date}',
  'cases.list.col.order': 'Ordine',
  'cases.list.col.companies': 'Aziende',
  'cases.list.col.have': 'Documenti',
  'cases.list.col.waitingFor': 'In attesa di',
  'cases.list.col.since': 'Da',
  'cases.list.col.waiting': 'In attesa',
  'cases.list.col.due': 'Scadenza',
  'cases.list.col.matched': 'Documenti',
  'cases.list.col.recovered': 'Recuperato',
  'cases.list.col.doneDate': 'Data di chiusura',
  'cases.list.weak': 'Floxir non è sicuro che questa fattura appartenga a questo ordine.',
  'cases.list.om.requestAll': 'Richiedi tutto a',
  'cases.list.bar.invoices': 'Richiedi le fatture a',
  'cases.list.bar.orders': 'Richiedi gli ordini a',
  'cases.list.late.weeks': 'Fattura mancante · {n} settimane dall\'ordine',
  'cases.list.late.days': 'Fattura mancante · {n} giorni dall\'ordine',
  'cases.list.late.week': 'Fattura mancante · 1 settimana dall\'ordine',
  'cases.list.late.day': 'Fattura mancante · 1 giorno dall\'ordine',
  'cases.list.internalPo': 'PO interno · fattura {n}',
  'cases.list.om.more.one': 'e 1 altro fornitore',
  'cases.list.om.more.many': 'e altri {n} fornitori',
  'cases.list.om.named': 'La fattura {n} ({date}) cita questo ordine, ma non è mai arrivato',
  'cases.list.om.namedNoDate': 'La fattura {n} cita questo ordine, ma non è mai arrivato',
  'cases.list.om.noInvoice': 'Una fattura cita questo ordine, ma non è mai arrivato',
  'cases.list.om.noRef': "Nessun numero d'ordine sulla fattura",
  'cases.list.dup': 'Stessa fattura {n} ricevuta due volte',
  'cases.list.dup.generic': 'Duplicato di una fattura precedente',
  'cases.list.reason.price': "Prezzo in fattura superiore all'ordine",
  'cases.list.reason.quantity': 'Quantità diversa tra i documenti',
  'cases.list.reason.billed_over_delivered': 'Fatturato più di quanto consegnato',
  'cases.list.reason.charge_not_ordered': "Costo fatturato, mai presente nell'ordine",
  'cases.list.reason.missing_line': "Non presente nell'ordine",
  'cases.list.reason.vat_error': "L'IVA non torna",
  'cases.list.reason.other': 'Da controllare',
  'cases.list.units': '{n} unità',
  'cases.list.daysOpen.one': 'aperta da 1 giorno',
  'cases.list.daysOpen.many': 'aperta da {n} giorni',
  'cases.list.days.one': '1 giorno',
  'cases.list.days.many': '{n} giorni',
  'cases.list.waiting.invoice': 'Fattura',
  'cases.list.waiting.delivery': 'Consegna',
  'cases.list.waiting.deliveryNote': 'Bolla di consegna',
  'cases.list.due.today': 'Oggi',
  'cases.list.due.in': 'tra {n} giorni',
  'cases.list.due.late': 'scaduta da {n} giorni',
  'cases.list.done.one': '1 pratica · {money} recuperati',
  'cases.list.done.many': '{n} pratiche · {money} recuperati',
  'cases.list.loading': 'Caricamento…',
  'cases.list.error': 'Al momento non è possibile caricare le pratiche.',
  'cases.list.summaryError': 'Al momento non è possibile caricare i conteggi.',
  'cases.list.empty': 'Nessuna pratica',
  'cases.list.empty.notBuilt': "Questo controllo non è ancora disponibile, quindi non c'è nulla da mostrare.",
  'cases.list.loadingMore': 'Caricamento di altre…',
  'cases.list.moreError': 'Non è stato possibile caricare altre pratiche.',
  'cases.list.showMore': 'Mostra altre',
  // ── Cases hub for agents (redesign step 3) ──
  'cases.hub.title': 'Pratiche',
  'cases.hub.attention': 'Da verificare',
  'cases.hub.open': 'Aperte',
  'cases.hub.matched': 'Corrispondenti',
  'cases.hub.done': 'Concluse',
  'cases.hub.history': 'Cronologia',
  'cases.hub.late': 'Documenti in ritardo {n}',
  'cases.hub.otherCurrency.one': '+ 1 pratica senza tasso di cambio',
  'cases.hub.otherCurrency.many': '+ {n} pratiche senza tasso di cambio',
  'cases.hub.error': 'Al momento non è possibile caricare i numeri delle pratiche.',
  'cases.hub.retry': 'Riprova',
  'cases.hub.filter.group': 'Aziende',
  'cases.hub.filter.all': 'Tutte le aziende',
  'cases.hub.filter.choose': 'Scegli aziende ▾',
  'cases.hub.filter.search': 'Cerca aziende',
  'cases.hub.filter.suppliers': 'Fornitori',
  'cases.hub.filter.apply': 'Mostra queste aziende',
  'cases.hub.filter.loading': 'Caricamento…',
  'cases.hub.filter.error': 'Al momento non è possibile caricare le aziende.',
  'cases.hub.filter.none': 'Nessuna azienda corrisponde',
  'cases.hub.filter.max': 'Puoi scegliere al massimo {n} aziende',
  'search.start': "Premi Cerca nel menu per cercare un numero d'ordine, un numero di fattura, un fornitore o un cliente",
  'search.none': 'Nessun risultato',
  'search.error': 'Ricerca non disponibile',
  'search.loading': 'Ricerca in corso…',
  'search.fileError': "Impossibile aprire il file originale",
  'search.title': 'Risultati per “{q}”',
  'search.count': '{n} risultati tra pratiche, documenti e aziende',
  'search.count.one': '1 risultato tra pratiche, documenti e aziende',
  'search.showing': 'Mostrati {shown} di {total}',
  'search.groupEmpty': 'Nessun risultato',
  'search.group.cases': 'Pratiche',
  'search.group.documents': 'Documenti',
  'search.group.companies': 'Aziende',
  'search.chip.attention': 'richiede attenzione',
  'search.chip.done': 'completata',
  'search.chip.open': 'aperta',
  'search.chip.matched': 'corrispondente',
  'search.po': 'Ordine {n}',
  'search.invoiceRef': 'Fattura {n}',
  'search.doc.purchase_order': 'Ordine di acquisto',
  'search.doc.invoice': 'Fattura',
  'search.doc.delivery_note': 'DDT',
  'search.doc.packing_list': 'Packing list',
  'search.doc.packing_slip': 'Bolla di imballaggio',
  'search.doc.document': 'Documento',
  'search.cites': 'cita {n}',
  'search.supplier': 'Fornitore',
  'search.customer': 'Cliente',
  'search.case.one': '1 pratica',
  'search.case.many': '{n} pratiche',
  'cases.nt.back': 'Torna alla Home',
  'cases.nt.export': 'Esporta elenco',
  'cases.nt.marker': 'Nuovo oggi',
  'cases.nt.loading': 'Caricamento…',
  'cases.nt.empty': 'Nessuna pratica',
  'cases.nt.error': 'Impossibile caricare l\'elenco in questo momento.',
  'cases.nt.truncated': 'Prime {n} pratiche su {total}.',
  'cases.nt.od.invoice': 'Fattura arrivata {n} giorni fa, in attesa del documento di trasporto',
  'cases.nt.od.delivery': 'Documento di trasporto arrivato {n} giorni fa, in attesa della fattura',
  'cases.nt.od.generic': 'Un documento manca da {n} giorni',
  'cases.nt.od.noInvoice': 'Ancora in attesa della fattura dopo {n} giorni',
  'cases.nt.csv.order': 'Ordine',
  'cases.nt.csv.supplier': 'Fornitore',
  'cases.nt.csv.buyer': 'Acquirente',
  'cases.nt.csv.invoice': 'Numero fattura',
  'cases.nt.csv.problem': 'Problema',
  'cases.nt.csv.description': 'Descrizione',
  'cases.nt.csv.amount': 'Importo',
  'cases.nt.csv.currency': 'Valuta',
  'cases.nt.csv.daysOpen': 'Giorni aperta',
  'cases.nt.csv.raisedOn': 'Segnalata il',
  'cases.hist.today': 'Oggi',
  'cases.hist.yesterday': 'Ieri',
  'cases.hist.type.order': 'Ordine',
  'cases.hist.type.invoice': 'Fattura',
  'cases.hist.type.delivery_note': 'Documento di trasporto',
  'cases.hist.type.packing_list': 'Packing list',
  'cases.hist.type.document': 'Documento',
  'cases.hist.title.full': '{type} {number} di {supplier}',
  'cases.hist.title.noSupplier': '{type} {number}',
  'cases.hist.title.noNumber': '{type} di {supplier}',
  'cases.hist.state.noCase': 'Nessuna pratica',
  'cases.hist.state.discrepancy': 'Discrepanza: {reason}',
  'cases.hist.state.order_missing': 'Ordine mancante',
  'cases.hist.state.matched': 'Abbinata',
  'cases.hist.state.done': 'Chiusa',
  'cases.hist.state.waiting': 'In attesa',
  'cases.hist.reason.price': 'prezzo diverso',
  'cases.hist.reason.quantity': 'quantità diversa',
  'cases.hist.reason.billed': 'fatturato più del consegnato',
  'cases.hist.reason.duplicate': 'fattura duplicata',
  'cases.hist.reason.vat': 'errore IVA',
  'cases.hist.reason.look': 'da controllare',
  'cases.hist.filter.supplier': 'Fornitore',
  'cases.hist.filter.type': 'Tipo di documento',
  'cases.hist.filter.allSuppliers': 'Tutti i fornitori',
  'cases.hist.filter.allDocuments': 'Tutti i documenti',
  'cases.hist.filter.type.order': 'Ordini',
  'cases.hist.filter.type.invoice': 'Fatture',
  'cases.hist.filter.type.delivery_note': 'Documenti di trasporto',
  'cases.hist.filter.type.packing_list': 'Packing list',
  'cases.hist.week.title': 'Questa settimana',
  'cases.hist.week.documents': 'Documenti ricevuti',
  'cases.hist.week.documents.sub': 'Tutti i tipi',
  'cases.hist.week.discrepancy': 'Discrepanze',
  'cases.hist.week.discrepancy.sub': 'Nuovi disaccordi',
  'cases.hist.week.late': 'Documenti in ritardo',
  'cases.hist.week.late.sub': 'In ritardo da questa settimana',
  'cases.hist.week.error': 'Impossibile caricare i numeri in questo momento.',
  'cases.hist.empty': 'Nessun documento.',
  'cases.hist.error': 'Impossibile caricare la cronologia in questo momento.',
  'case.back.attention': 'Torna a Da verificare',
  'case.back.open': 'Torna a Aperte',
  'case.back.matched': 'Torna a Abbinate',
  'case.back.done': 'Torna a Chiuse',
  'case.back.cases': 'Torna alle pratiche',
  'case.title.fallback': 'Pratica',
  'case.sub.opened': 'Ordine {po} · aperta il {date}',
  'case.sub.openedNoPo': 'Aperta il {date}',
  'case.sub.closed': 'Ordine {po} · chiusa il {date}',
  'case.sub.closedNoPo': 'Chiusa il {date}',
  'case.sub.received': 'Fattura {inv} · ricevuta il {date}',
  'case.sub.receivedNoInv': 'Fattura ricevuta il {date}',
  'case.sub.case': 'pratica {n}',
  'case.chip.attention': 'Da verificare',
  'case.chip.open': 'Aperta',
  'case.chip.matched': 'Abbinata',
  'case.chip.internal_po': 'PO interno',
  'case.chip.low_confidence': 'Bassa affidabilità',
  'case.chip.done': 'Chiusa',
  'case.card.order': 'Ordine',
  'case.card.confirmation': 'Conferma',
  'case.card.delivery': 'Consegna',
  'case.card.invoice': 'Fattura',
  'case.card.paid': 'Pagata',
  'case.status.matched': 'Corrisponde',
  'case.status.differs': 'Differisce',
  'case.status.missing': 'Mancante',
  'case.status.received': 'Ricevuta',
  'case.status.waiting': 'In attesa',
  'case.status.not_due': 'Non scaduta',
  'case.status.done': 'Chiusa',
  'case.order.lines.one': '1 riga · {total}',
  'case.order.lines.many': '{n} righe · {total}',
  'case.order.names': 'La fattura cita l’ordine {n}',
  'case.order.never': 'Mai ricevuto',
  'case.order.internal': 'PO interno · dalla fattura {n}',
  'case.problem.ipoTitle': 'PO interno',
  'case.problem.ipoLabel': 'Su questa pratica',
  'case.problem.ipoTotal': 'Totale fattura {total}',
  'case.status.internal_po': 'Non confrontato',
  'case.problem.ipoBody': 'La fattura {n} non indica nessun ordine, quindi Floxir ne ha creato uno dalle righe. Non viene confrontato con nulla.',
  'case.problem.ipoBodyCited': 'La fattura indica {po}, che non è mai arrivato. Floxir ha creato un ordine dalle righe della fattura; nulla viene controllato finché non arriva quello vero.',
  'case.step.po_received': 'Ordine ricevuto',
  'case.step.invoice_received': 'Fattura ricevuta',
  'case.step.matched': 'Corrispondente',
  'types.action.request_invoices': 'Richiedi le fatture',
  'case.confirmation.own': 'Numero proprio di {supplier}',
  'case.confirmation.ownNoSupplier': 'Numero proprio del fornitore',
  'case.notReceived': 'Non ricevuta',
  'case.delivery.note': 'Documento di trasporto {n}',
  'case.delivery.noteNoNumber': 'Documento di trasporto',
  'case.delivery.packing': 'Packing list {n}',
  'case.delivery.packingNoNumber': 'Packing list',
  'case.delivery.pct': '{pct}% consegnato · {date}',
  'case.delivery.pctNoDate': '{pct}% consegnato',
  'case.delivery.on': 'Consegnato il {date}',
  'case.invoice.due': '{total} · scade il {date}',
  'case.invoice.total': '{total}',
  'case.invoice.more.one': '+1 altra fattura',
  'case.invoice.more.many': '+{n} altre fatture',
  'case.paid.notDue': 'Non ancora scaduta',
  'case.paid.waiting': 'In attesa della rimessa',
  'case.paid.due': 'Scade il {date}',
  'case.paid.dueUnknown': 'Scadenza non indicata in fattura',
  'case.btn.formatted': 'Formattato',
  'case.btn.original': 'Originale',
  'case.lines.title': 'Riga per riga',
  'case.lines.sub.full': 'Ordine, consegna e fattura affiancati',
  'case.lines.sub.invoice_only': 'Solo dalla fattura',
  'case.lines.sub.done': 'Ordine, consegna e fattura affiancati',
  'case.lines.empty': 'Questa pratica non ha ancora righe.',
  'case.col.item': 'Articolo',
  'case.col.ordered': 'Ordinato',
  'case.col.orderPrice': 'Prezzo ordine',
  'case.col.delivered': 'Consegnato',
  'case.col.invoiced': 'Fatturato',
  'case.col.invoicePrice': 'Prezzo fattura',
  'case.col.difference': 'Differenza',
  'case.col.creditNote': 'Nota di credito',
  'case.col.final': 'Finale',
  'case.problem.difference': 'La differenza',
  'case.problem.problem': 'Il problema',
  'case.problem.standing': 'A che punto è',
  'case.problem.recovered': 'Recuperato',
  'case.problem.price': 'Il prezzo in fattura supera quello dell’ordine su {n} righe su {m}.',
  'case.problem.quantity': 'La quantità fatturata supera l’ordine su {n} righe su {m}.',
  'case.problem.billed_over_delivered': 'Fatturato più del consegnato su {n} righe su {m}.',
  'case.problem.priceDetail': '{supplier} ha fatturato {billed} ciascuno. L’ordine diceva {agreed}.',
  'case.problem.duplicate': 'La stessa fattura {n} ricevuta due volte.',
  'case.problem.duplicateNoNumber': 'La stessa fattura è stata ricevuta due volte.',
  'case.problem.weak': 'Floxir non è sicuro che questa fattura appartenga a questo ordine.',
  'case.problem.weakHint': 'Controlla l’ordine e la fattura qui sopra.',
  'case.problem.omTitle': 'L’ordine {po} non è mai arrivato',
  'case.problem.omTitleNoRef': 'Un ordine non è mai arrivato',
  'case.problem.omBody': 'La fattura di {supplier} cita questo ordine, ma Floxir non l’ha ricevuto.',
  'case.problem.omBodyNoRef': 'La fattura di {supplier} non indica un numero d’ordine e Floxir non ha un ordine per essa.',
  'case.problem.omTotal': 'Il totale fattura {total} non può essere controllato finché l’ordine non arriva.',
  'case.problem.waitingInvoice': 'In attesa della fattura.',
  'case.problem.waitingDelivery': 'In attesa del documento di trasporto.',
  'case.problem.matched': 'La fattura corrisponde all’ordine. In attesa del documento di trasporto.',
  'case.problem.nothing': 'Non manca nulla.',
  'case.problem.accepted': 'Accettato',
  'case.problem.recoveredHint': 'Floxir non legge ancora le note di credito, quindi nulla è contato come recuperato.',
  'case.problem.fallback': 'Da controllare',
  'case.status.placeholder': 'Provvisorio',
  'case.order.placeholder': 'Ordine provvisorio dalla fattura · Creato da Floxir',
  'case.confirm.approve.title': 'Approvare così com’è?',
  'case.confirm.approve.text': 'La differenza resta registrata. La pratica passa a Chiuse e la fattura risulta approvata.',
  'case.confirm.approve.yes': 'Approva',
  'case.confirm.reopen.title': 'Riaprire questa pratica?',
  'case.confirm.reopen.text': 'Torna allo stato che indicano i suoi documenti.',
  'case.confirm.reopen.yes': 'Riapri',
  'case.confirm.create_from_invoice.title': 'Creare un ordine provvisorio?',
  'case.confirm.create_from_invoice.text': 'Ha l’etichetta “Creato da Floxir”, non viene mai usato per controllare questa pratica e viene sostituito quando arriva l’ordine vero.',
  'case.confirm.create_from_invoice.yes': 'Crea ordine provvisorio',
  'case.confirm.cancel': 'Annulla',
  'case.action.err.closed': 'Questa pratica è già chiusa.',
  'case.action.err.notApprovable': 'Questa pratica non può essere approvata.',
  'case.action.err.failed': 'Impossibile salvare. Non è stato modificato nulla.',
  'case.action.request_correction_followup': 'Invia sollecito',
  'case.action.request_order_followup': 'Invia sollecito',
  'case.req.loading': 'Preparo il messaggio…',
  'case.req.to': 'A',
  'case.req.subject': 'Oggetto',
  'case.req.message': 'Messaggio',
  'case.req.from.invoice': 'Dall’ultima fattura di {supplier}',
  'case.req.from.supplier': 'Dai dati del fornitore',
  'case.req.from.none': 'Nessun indirizzo per {supplier}. Scrivine uno per inviare.',
  'case.req.unknown': 'Questo indirizzo non risulta tra quelli di {supplier}',
  'case.req.full': 'Sarà inviato a {address}',
  'case.req.test': 'Modalità di prova: il messaggio viene registrato ma non inviato',
  'case.req.cancel': 'Annulla',
  'case.req.close': 'Chiudi',
  'case.req.send': 'Invia richiesta',
  'case.req.sendFollowup': 'Invia sollecito',
  'case.req.sending': 'Invio…',
  'case.req.recorded': 'Registrato, non inviato. È la modalità di prova.',
  'case.req.err.load': 'Impossibile preparare il messaggio.',
  'case.req.err.send': 'Impossibile inviare il messaggio.',
  'case.req.attach.title': 'Allegati',
  'case.req.attach.none': 'Nessun file da allegare.',
  'case.req.attach.total': 'Totale {size} su 20 MB',
  'case.req.attach.size.unknown': 'dimensione sconosciuta',
  'case.req.attach.reason.missing': 'File originale non conservato',
  'case.req.attach.reason.too_big': 'Troppo grande (limite 10 MB per file)',
  'case.req.attach.reason.over_total': 'Supererebbe i 20 MB',
  'case.req.attach.note': 'Aggiunto al messaggio quando viene inviato:',
  'case.req.err.unavailable': 'Impossibile leggere {file}. Deseleziona il file o riprova. Non è stato inviato nulla.',
  'case.req.err.tooBig': '{file} supera il limite di 10 MB. Deselezionalo. Non è stato inviato nulla.',
  'case.req.err.totalBig': 'I file insieme superano i 20 MB. Deseleziona un file. Non è stato inviato nulla.',
  'case.reqall.title': 'Richiedi tutto a {supplier}',
  'case.reqall.orders': 'Ordini',
  'case.reqall.counter': '{n} di {max} selezionati',
  'case.reqall.asked': 'Richiesto il {date}',
  'case.reqall.noInvoiceFile': 'Nessun file di fattura',
  'case.reqall.more': '{n} non inclusi. Invia questa email, poi richiedi di nuovo.',
  'case.reqall.truncated': 'Sono elencati solo i primi 300.',
  'case.reqall.attachInvoices': 'Allega le fatture',
  'case.reqall.empty': 'Niente da richiedere: questo fornitore non ha ordini mancanti in queste date.',
  'case.reqall.err.changed': 'L’elenco è cambiato (potrebbe essere arrivato un ordine). Non è stato inviato nulla.',
  'case.reqall.reload': 'Ricarica l’elenco',
  'case.problem.weakEv.other': 'La fattura {inv} indica l’ordine {ref}. L’ordine di questa pratica è {po}.',
  'case.problem.weakEv.none': 'La fattura {inv} non indica nessun ordine. L’ordine di questa pratica è {po}.',
  'case.problem.weakEv.this': 'La fattura {inv} indica questo ordine ({po}).',
  'case.confirm.confirm_order.title': 'Confermare questo ordine?',
  'case.confirm.confirm_order.text': 'Floxir smette di segnalare questa corrispondenza. La pratica segue le regole normali.',
  'case.confirm.confirm_order.yes': 'Conferma',
  'case.confirm.not_this_order.title': 'Non è questo ordine?',
  'case.confirm.not_this_order.text': 'La fattura esce da questa pratica e diventa una pratica Ordine mancante a sé. Questa pratica torna in attesa di una fattura.',
  'case.confirm.not_this_order.textSome': 'Le fatture che non indicano questo ordine escono, ognuna in una pratica a sé. Le altre restano.',
  'case.confirm.not_this_order.yes': 'Sposta la fattura',
  'case.action.err.notWeak': 'Questa pratica non è più una corrispondenza incerta.',
  'case.action.err.noInvoice': 'Questa pratica non ha fatture.',
  'case.action.err.namesOrder': 'Tutte le fatture di questa pratica indicano questo ordine.',
  'case.action.err.shared': 'Questa fattura è divisa su più ordini, quindi non può essere spostata da qui.',
  'case.next.button': 'Pratica successiva →',
  'case.next.position': 'Nuove oggi · {n} di {total}',
  'case.next.last': 'Era l’ultima pratica dell’elenco.',
  'case.next.back': 'Torna all’elenco',
  'cases.hist.filter.flagged': 'Solo segnalati',
  'cases.hist.emptyFlagged': 'Nessun documento segnalato.',
  'case.other.title': 'Collegate ma citano un altro ordine',
  'case.other.one': '1 fattura di questa pratica cita un altro ordine. Non è conteggiata negli importi di questa pratica.',
  'case.other.many': '{n} fatture di questa pratica citano un altro ordine. Non sono conteggiate negli importi di questa pratica.',
  'case.other.row': 'Fattura {inv} · cita {ref}',
  'case.multi.title': 'Copre più ordini',
  'case.multi.one': '1 fattura di questa pratica copre più ordini. Il totale non viene confrontato con questo solo ordine; i controlli riga per riga restano attivi.',
  'case.multi.many': '{n} fatture di questa pratica coprono più ordini. I totali non vengono confrontati con questo solo ordine; i controlli riga per riga restano attivi.',
  'case.multi.row': 'Fattura {inv} · copre {n} ordini',
  'case.action.not_duplicate': 'Non è un duplicato',
  'case.confirm.not_duplicate.title': 'Non è un duplicato?',
  'case.confirm.not_duplicate.text': 'La fattura resta in questa pratica come fattura normale e conta nei totali. Floxir non la segnerà più come duplicato.',
  'case.confirm.not_duplicate.yes': 'Non è un duplicato',
  'case.action.err.notCopy': 'Nessuna fattura di questa pratica è segnata come copia.',
  'case.step.not_duplicate': 'Segnata come non duplicato',
  'case.actions.title': 'Cosa vuoi fare?',
  'case.action.request_correction': 'Chiedi correzione',
  'case.action.approve': 'Approva così com’è',
  'case.action.reopen': 'Riapri la pratica',
  'case.action.request_order': 'Chiedi l’ordine',
  'case.action.create_from_invoice': 'Crea dalla fattura',
  'case.action.confirm_order': 'Conferma questo ordine',
  'case.action.not_this_order': 'Non è questo ordine',
  'case.actions.hint.correction': 'Chiedi correzione prepara un’email a {supplier} con i documenti allegati.',
  'case.actions.hint.order': 'Chiedi l’ordine scrive a {supplier} per {po}. Crea dalla fattura costruisce un ordine provvisorio con l’etichetta "Creato da Floxir", sostituito quando arriva l’ordine vero.',
  'case.actions.hint.orderNoRef': 'Chiedi l’ordine scrive a {supplier} per l’ordine. Crea dalla fattura costruisce un ordine provvisorio con l’etichetta "Creato da Floxir", sostituito quando arriva l’ordine vero.',
  'case.actions.hint.weak': 'Conferma questo ordine, oppure indica che non è quello giusto.',
  'case.actions.hint.reopen': 'Questa pratica è stata approvata così com’è. Riaprila solo se arriva un nuovo documento o una contestazione.',
  'case.actions.hint.closedAgreed': 'Questa pratica è chiusa perché i documenti corrispondono.',
  'case.timeline.title': 'Cronologia della pratica',
  'case.step.discrepancy': 'Discrepanza',
  'case.step.opened': 'Aperta',
  'case.step.correction_requested': 'Correzione richiesta',
  'case.step.order_requested': 'Ordine richiesto',
  'case.step.invoice_requested': 'Fattura richiesta',
  'case.step.approved_as_is': 'Approvata così com’è',
  'case.step.order_confirmed': 'Ordine confermato',
  'case.step.order_rejected': 'Segnata come non questo ordine',
  'case.step.placeholder_created': 'Ordine provvisorio creato',
  'case.step.placeholder_replaced': 'Ordine vero ricevuto',
  'case.step.reopened': 'Riaperta',
  'case.step.credit_note': 'Nota di credito',
  'case.step.done': 'Chiusa',
  'case.step.open': 'Aperta',
  'case.step.order_received': 'Ordine ricevuto',
  'case.step.checked': 'Controllata',
  'case.stepText.reason.price': 'prezzo sopra l’ordine',
  'case.stepText.reason.quantity': 'quantità diversa',
  'case.stepText.reason.billed_over_delivered': 'fatturato più del consegnato',
  'case.stepText.reason.duplicate': 'fattura duplicata',
  'case.stepText.reason.vat_error': 'errore IVA',
  'case.stepText.reason.weak_match': 'abbinamento incerto',
  'case.stepText.reason.other': 'da controllare',
  'case.stepText.reason.order_missing': 'la fattura cita {po}, mai ricevuto',
  'case.stepText.reason.order_missing_noref': 'fattura senza ordine, mai ricevuto',
  'case.stepText.emailTo': 'email a {supplier}',
  'case.stepText.sentToday': 'Inviata oggi',
  'case.stepText.sentOne': 'Inviata 1 giorno fa',
  'case.stepText.sentMany': 'Inviata {n} giorni fa',
  'case.stepText.by': 'da {who}',
  'case.stepText.notRequested': '—',
  'case.stepText.none': '—',
  'case.stepText.open': 'chiedi l’ordine o crealo dalla fattura',
  'case.stepText.agreed': 'i documenti corrispondono',
  'case.stepText.accepted': 'approvata così com’è',
  'case.stepText.estimated': 'stimato',
  'case.loading': 'Caricamento…',
  'case.error': 'Impossibile caricare la pratica in questo momento.',
  'case.notFound': 'Pratica non trovata.',
  ...reportsAgentIt,
  ...step5It,
};

export default it;
